import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

import { Logger } from 'src/app/services/logger.service';
import { ConfirmModalService } from 'src/app/components/modals/confirm-modal.service';
import { Role } from '../models';

const log = new Logger('AuthGuard')
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(
    private _router: Router,
    private _confirmModalService: ConfirmModalService,
    private _authenticationService: AuthenticationService) { }

  // canActivate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this._authenticationService.currentUserValue;
    const currentToken = this._authenticationService.currentTokenValue;
    if (currentToken && currentUser) {
      const isTokenExp = this.tokenExpired(currentToken.refreshToken)

      if (!isTokenExp) {

        this._confirmModalService.ok('Token Expired!!!', 'Login Again').then(() => {
          this._authenticationService.logout();
          this._router.navigate(['sign-in']);
        })
        return false;
      }
      return true;

    }
    this._router.navigate(['sign-in']);
    return false;
  }

  tokenExpired(refreshToken: string) {
    const expiry = (JSON.parse(atob(refreshToken.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) < expiry;
  }
}

@Injectable({ providedIn: 'root' })
export class EngineerRoleGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _confirmModalService: ConfirmModalService,
    private _authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this._authenticationService.currentUserValue;
    const currentToken = this._authenticationService.currentTokenValue;
    
    // ตรวจสอบ authentication ก่อน
    if (!currentToken || !currentUser) {
      this._router.navigate(['sign-in']);
      return false;
    }

    // ตรวจสอบ token expiration
    const isTokenExp = this.tokenExpired(currentToken.refreshToken);
    if (!isTokenExp) {
      this._confirmModalService.ok('Token Expired!!!', 'Login Again').then(() => {
        this._authenticationService.logout();
        this._router.navigate(['sign-in']);
      });
      return false;
    }

    // ตรวจสอบ role - อนุญาตเฉพาะ TECHNICIAN (engineer)
    if (currentUser.role === Role.ENGINEER) {
      log.debug('User has ENGINEER role, access granted');
      return true;
    }

    // ถ้าไม่มีสิทธิ์ ให้แสดงข้อความและ redirect
    log.warn('User does not have ENGINEER role, access denied. Current role:', currentUser.role);
    this._confirmModalService.errorAlert(
      'ไม่มีสิทธิ์เข้าถึง',
      'หน้านี้สามารถเข้าถึงได้เฉพาะผู้ที่มีสิทธิ์ ENGINEER เท่านั้น',
      3000
    ).then(() => {
      this._router.navigate(['tab-home']);
    });
    
    return false;
  }

  tokenExpired(refreshToken: string) {
    const expiry = (JSON.parse(atob(refreshToken.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) < expiry;
  }
}
